import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=0b7d5526"
import script from "./Topic.vue?vue&type=script&setup=true&lang=js"
export * from "./Topic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Topic.vue?vue&type=style&index=0&id=0b7d5526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports